<div class="ibox-content">
  <form [formGroup]="form">
    <div class="form-group row">
      <mat-error *ngIf="MensajeError" class="eliminacionInvalida">{{MensajeError}}</mat-error>
    </div>
    <div class="row" hidden="true">
      <input formControlName="id" name="id" type="text" class="form-control" />
      <input formControlName="personal" name="personal" type="text" class="form-control" />
    </div>
    <div class="row panel panel-warning" *ngIf="!disabledEditing">
      <div class="col-lg">
        <label class="col-lg-3 col-form-label font-bold" for="desde">Desde</label>
        <div class="col-lg-8">
          <p-calendar appendTo="body" selectOtherMonths="true" formControlName="desde" dateFormat="dd/mm/yy" inputId="desde" ngDefaultControl></p-calendar>
          <div *ngIf="!desdeAnterior && registerFormControl.desde.errors?.required && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched)" class="text-danger">La Fecha es Requerida</div>
          <mat-error *ngIf="desdeAnterior && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
            La fecha no puede ser anterior al {{ingreso.desde | date:'dd/MM/yyyy'}}
          </mat-error>
        </div>
      </div>
      <div class="col-lg">

        <label class="col-lg-3 col-form-label font-bold" for="hasta">Hasta</label>
        <div class="col-lg-8">
          <p-calendar appendTo="body" selectOtherMonths="true" formControlName="hasta" dateFormat="dd/mm/yy" inputId="hasta" ngDefaultControl></p-calendar>
          <div *ngIf="registerFormControl.hasta.errors?.required && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)" class="text-danger">La Fecha es Requerida</div>
          <mat-error  class="text-danger" *ngIf="registerFormControl.hasta.errors?.fecHastaMenor && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)">
            La Fecha no puede ser menor que la Fecha Desde
          </mat-error>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg">
        <label class="col-form-label font-bold">Clase</label>
        <div>
          <comboTools [list]=clasesDireccionList
                      selected='clase'
                      [formParent]="form"
                      [isEditing]=disabledEditing
                      filter="descripcion" 
                      ph='Clase'></comboTools>
          <div *ngIf="registerFormControl.clase.invalid && (registerFormControl.clase?.dirty || registerFormControl.clase?.touched || submitted)" class="text-danger">
            La Clase es Requerida
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-lg">
        <label class=" col-form-label font-bold">Calle</label>
        <input formControlName="calle" maxlength="50" name ="selectedCalle" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.calle.errors && (registerFormControl.calle?.dirty || registerFormControl.calle?.touched || submitted)}"/>
        <mat-error  class="text-danger"*ngIf="registerFormControl.calle.errors?.required && (registerFormControl.calle?.dirty || registerFormControl.calle?.touched || submitted)">
            La Calle es Requerida
        </mat-error>
      </div>
      <div class="col-lg">
        <label class=" col-form-label font-bold">Nro</label>
        <input formControlName="nro" name ="selectedNro" type="number" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.nro.errors && (registerFormControl.nro?.dirty || registerFormControl.nro?.touched || submitted)}"/>
        <mat-error  class="text-danger"*ngIf="registerFormControl.nro.errors?.required && (registerFormControl.nro?.dirty || registerFormControl.nro?.touched || submitted)">
            El Nro es Requerido
        </mat-error>
      </div>
    </div>
    <div class="row">
      <div class="col-lg">
        <label class=" col-form-label font-bold">Piso</label>
        <input formControlName="piso" name ="selectedPiso" maxlength="4" class="form-control"/>
      </div>
      <div class="col-lg">
        <label class=" col-form-label font-bold">Depto</label>
        <input formControlName="dpto" name ="selectedDepto" maxlength="4" class="form-control"/>
      </div>
    </div>
    <div class="row">
      <div class="col-lg">
        <label class=" col-form-label font-bold">Localidad</label>
        <input formControlName="localidad" name ="selectedLocalidad" maxlength="50" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.localidad.errors && (registerFormControl.localidad?.dirty || registerFormControl.localidad?.touched || submitted)}"/>
        <mat-error  class="text-danger"*ngIf="registerFormControl.localidad.errors?.required && (registerFormControl.localidad?.dirty || registerFormControl.localidad?.touched || submitted)">
            La Localidad es Requerida
        </mat-error>
      </div>
      <div class="col-lg">
        <label class=" col-form-label font-bold">Código Postal</label>
        <input formControlName="codPos" name ="selectedCodPos" type="number" maxlength="4" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.codPos.errors && (registerFormControl.codPos?.dirty || registerFormControl.codPos?.touched || submitted)}"/>
        <mat-error  class="text-danger"*ngIf="registerFormControl.codPos.errors?.required && (registerFormControl.codPos?.dirty || registerFormControl.codPos?.touched || submitted)">
            El Código Postal es Requerido
        </mat-error>
      </div>
    </div>
    <div class="row">
      <div class="col-lg">
        <label class="col-form-label font-bold">País</label>
        <div>
          <comboTools [list]=paisesList
                      selected='pais'
                      [formParent]="form"
                      [isEditing]=disabledEditing
                      filter="descripcion"
                      (SelectedChange)="onChangePais($event)"></comboTools>
          <div *ngIf="registerFormControl.pais.invalid && (registerFormControl.pais?.dirty || registerFormControl.pais?.touched || submitted)" class="text-danger">
            El País es Requerido
          </div>
        </div>
      </div>
      <div class="col-lg">
        <label class="col-form-label font-bold">Provincia</label>
        <div>
          <comboTools [list]=provinciasList
                      selected='provincia'
                      [formParent]="form"
                      [isEditing]=disabledEditing
                      filter="descripcion"></comboTools>
          <div *ngIf="registerFormControl.provincia.invalid && (registerFormControl.provincia?.dirty || registerFormControl.provincia?.touched || submitted)" class="text-danger">
            La Provincia es Requerida
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-lg">
        <label class=" col-form-label font-bold">Teléfono</label>
        <input formControlName="telefono" name ="selectedTelefono" maxlength="50" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.telefono.errors && (registerFormControl.telefono?.dirty || registerFormControl.telefono?.touched || submitted)}"/>
        <mat-error  class="text-danger"*ngIf="registerFormControl.telefono.errors?.required && (registerFormControl.telefono?.dirty || registerFormControl.telefono?.touched || submitted)">
            El Teléfono es Requerido
        </mat-error>
      </div>
      <div class="col-lg">
        <label class=" col-form-label font-bold">Observaciones</label>
        <input formControlName="observaciones" name ="selectedObservaciones" maxlength="50" class="form-control"/>
      </div>
    </div>
  </form>
</div>

